<template>
	<article class="personalcenter_page">
		<section class="userinfo">
			<img class="userinfo_avatar" v-if="!driverData && !driverData.HeadPic" :src="driverData.HeadPic" />
			<img class="userinfo_avatar" v-else src="/../static/img/defaultdriverheadpic.jpg" />

			<p>
				<span class="userinfo_nickname">{{ driverData.DriverName }}[{{ driverData.IsPrivate ? '雇佣' : '外援' }}]</span>
			</p>
			<p>
				<span class="userinfo_nickname">{{ driverData.CardNO }}</span>
			</p>
		</section>

		<section class="mylist">
			<button class="mylist_item flex_wrap j_c_between my_passenger_information" @click="showMyJobList" :disabled="!driverData.Status">
				<i class="iconfont icon-wodeziliao1"></i>
				<span>我的工单</span>
				<i class="iconfont icon-iconfontzhizuobiaozhun19"></i>
			</button>
			<button class="mylist_item flex_wrap j_c_between" @click="showMyStatistical" :disabled="!driverData.Status">
				<i class="iconfont icon-bianji2"></i>
				<span>工单统计</span>
				<i class="iconfont icon-iconfontzhizuobiaozhun19"></i>
			</button>
			<button class="mylist_item flex_wrap j_c_between" @click="showUpdateInfoPage" :disabled="!driverData.Status">
				<i class="iconfont icon-jifen1"></i>
				<span>更新司机信息</span>
				<i class="iconfont icon-iconfontzhizuobiaozhun19"></i>
			</button>
			<!-- <button class="mylist_item flex_wrap j_c_between" @click="showErrorTips">
				<i class="iconfont icon-huiyuanquanyi golden_color"></i>
				<span>会员权益及收费标准</span>
				<i class="iconfont icon-iconfontzhizuobiaozhun19"></i>
			</button>
			<button class="mylist_item my_site flex_wrap j_c_between" @click="showMyAddress">
				<i class="iconfont icon-zhiyuandidian4"></i>
				<span>我的常用地址</span>
				<i class="iconfont icon-iconfontzhizuobiaozhun19"></i>
			</button>
			<button class="mylist_item flex_wrap j_c_between" @click="showErrorTips">
				<i class="iconfont icon-youhuiquan2"></i>
				<span>我的优惠券</span>
				<i class="iconfont icon-iconfontzhizuobiaozhun19"></i>
			</button> -->
		</section>
	</article>
</template>

<script>
import { mapState } from 'vuex';
import driverApi from '@/request/driverApi';

export default {
	name: 'DriverMainPage',
	data() {
		return {
			driverData: {},
			pageData: null,
			isRegister: false
		};
	},
	activated() {
		this.getDriverData();
	},
	methods: {
		getDriverData() {
			let that = this;
			this.tmpTimer = setInterval(() => {
				this.$Spin.show();
				if (this.OpenId && this.OpenId.length > 0) {
					clearInterval(this.tmpTimer);
					driverApi.getDriverData(this.OpenId).then(sucRes => {
						if (sucRes.success) {
							this.driverData = sucRes.data;
							this.isRegister = true;
							this.getPageData();
						} else {
							this.isRegister = false;							
							alert(sucRes.message);
							this.showUpdateInfoPage();
						}
						this.$Spin.hide();
					});
				}
			}, 500);
		},
		getPageData() {},
		showMyJobList() {
			this.$router.push({
				name: 'DriverJobList'
			});
		},
		showMyStatistical() {
			this.$router.push({
				name: 'DriverJobStatistical'
			});
		},
		showUpdateInfoPage() {
			this.$router.push({
				name: 'DriverInfoRegister'
			});
		}
	},
	computed: mapState({
		OpenId: state => state.user.OpenId,
		// OpenId: 'oDcOv55qrbQqkAtX4p3uswrbbG8c',
		userData: state => state.user.userData
	})
};
</script>

<style lang="less" scoped>
@import '../style/public';
.userinfo {
	.flex_wrap(center, center, initial, column);
}
.userinfo {
	background-color: #E77618;
	width: 100%;
	height: 22vh;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	color: #fff;
	padding: 1em 0;
	/* position: relative */
}
.userinfo > p {
	font-size: 0.4rem;
	margin-top: 10px;
}
.vipicon {
	/* position: absolute;
    right: 40%;
    bottom: 32%; */
	font-size: 0.5rem !important;
	margin: 0 0 0 5px !important;
	background: linear-gradient(45deg, #ffd900 20%, #fff 50%, #ffd700 80%);
	-webkit-background-clip: text;
	color: transparent;
	/* color: #ffd700 */
}
.userinfo_avatar {
	width: 2rem;
	height: 2rem;
	border-radius: 50%;
	/*margin: 1em;*/
}
.mylist {
	flex: 1;
	overflow: auto;
}
.mylist_item {
	width: 100%;
	padding: 0 3%;
	font-size: 0.45rem;
	border: none;
	line-height: 8vh;
	background-color: #f8f8f8;
	border-bottom: 1px solid #888;
	.flex_wrap(space-between, center);
}
.mylist_item > i {
	font-size: 0.6rem;
	flex: 0 0 10%;
}
.mylist_item > span {
	flex: 1;
	text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/DriverMainPage.vue